import React, { useEffect, useState } from "react";
import DetailSheet from "../session/generate/DetailSheet";
import { Button } from "../ui/button";
import { Input } from "../ui/input";

/**
 * Names each round of a repeating block before it is split into one block per
 * round ("Set × 3" → Burpees, Squats, Push-ups). Fields start blank: a blank
 * round keeps its current name, so only the rounds worth naming need typing.
 */
const SplitRoundsSheet = ({ node, onOpenChange, onSplit }) => {
  const rounds = Number(node?.value) || 0;
  const [names, setNames] = useState([]);

  useEffect(() => {
    if (node) setNames(Array(rounds).fill(""));
  }, [node, rounds]);

  return (
    <DetailSheet
      open={Boolean(node)}
      onOpenChange={onOpenChange}
      title="Split into rounds"
      description={`"${node?.label || "Block"}" becomes its ${rounds} rounds, one after another. Name each for what you did in it.`}
      showDescription
      footer={
        <div className="flex gap-2">
          <Button
            type="button"
            variant="ghost"
            className="h-12 flex-1 text-base"
            onClick={() => onOpenChange(false)}
          >
            Cancel
          </Button>
          <Button
            type="button"
            className="h-12 flex-1 text-base font-semibold"
            onClick={() => onSplit(names)}
          >
            Split
          </Button>
        </div>
      }
    >
      <div className="space-y-2">
        {names.map((name, i) => (
          <Input
            key={i}
            value={name}
            aria-label={`Round ${i + 1} name`}
            placeholder={`Round ${i + 1}`}
            onChange={(e) =>
              setNames((prev) => prev.map((n, k) => (k === i ? e.target.value : n)))
            }
            className="h-11 text-base"
          />
        ))}
      </div>
    </DetailSheet>
  );
};

export default SplitRoundsSheet;
